import React, { useContext } from "react";
import { NotificationManager } from "react-notifications";
import instance from "../../../../common/api/interceptor";
import FieldDate from "../../../../common/component/form/FieldDate";
import FieldText from "../../../../common/component/form/FieldText";
import FieldTime from "../../../../common/component/form/FieldTime";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ModalBox from "../../../../common/component/Modal/Index";
import useForm from "../../../../common/hooks/useForm";
import { path } from "../../../../constants/apiPath";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { StoreContext } from "../../../../store";
import moment from "moment";
import { filterDataObject } from "../data/FilterDataObject";

function FilterModal({ setLoading, onFillterHandler, pageSize, bodyData }) {
  const OrderNumber = useForm();
  const shipmentNumber = useForm();
  const incoTerm = useForm();
  const orderStatus = useForm();
  const orderDateFrom = useForm();
  const orderDateTo = useForm();
  const containerMode = useForm();
  const transportMode = useForm();
  const SupplierName = useForm();
  const SupplierCode = useForm();
  const BuyerName = useForm();
  const BuyerCode = useForm();
  const sendingAgentCode = useForm();
  const sendingAgentName = useForm();
  const recievingAgentCode = useForm();
  const recievingAgentName = useForm();
  const ETDFromDate = useForm();
  const ETDToDate = useForm();
  const ETAFromDate = useForm();
  const ETAToDate = useForm();
  const CutOffFromDate = useForm();
  const CutOffToDate = useForm();
  const mblNumber = useForm();
  const containerNumber = useForm();
  const Vessel = useForm();
  const Voyage = useForm();
  const CarrierCode = useForm();
  const OriginPortCode = useForm();
  const DestinationPortCode = useForm();
  const Orgnisation = useForm();
  const context = useContext(StoreContext);
  const onApplyFilters = async () => {
    const body = {
      OrderNumber: OrderNumber.value,
      ShipmentNumber: shipmentNumber.value,
      Incoterm: incoTerm.value,
      OrderStatus: orderStatus.value,
      OrderFromDate: orderDateFrom.value
        ? moment(orderDateFrom.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      OrderToDate: orderDateTo.value
        ? moment(orderDateTo.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      Container: containerNumber.value,
      BuyerCode: BuyerCode.value,
      BuyerName: BuyerName.value,
      SupplierCode: SupplierCode.value,
      SupplierName: SupplierName.value,
      ContainerMode: containerMode.value,
      TransportMode: transportMode.value,
      Vessel: Vessel.value,
      Voyage: Voyage.value,
      CarrierCode: CarrierCode.value,
      OPortCode: OriginPortCode.value,
      OPortName: "",
      DPortCode: DestinationPortCode.value,
      DPortName: "",
      SAgentCode: sendingAgentCode.value,
      SAgentName: sendingAgentName.value,
      RAgentCode: recievingAgentCode.value,
      RAgentName: recievingAgentName.value,
      ETDFromDate: ETDFromDate.value
        ? moment(ETDFromDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      ETDToDate: ETDToDate.value
        ? moment(ETDToDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      ETAFromDate: ETAFromDate.value
        ? moment(ETAFromDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      ETATDate: ETAToDate.value
        ? moment(ETAToDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      CutOffFromDate: CutOffFromDate.value
        ? moment(CutOffFromDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      CutOffToDate: CutOffToDate.value
        ? moment(CutOffToDate.value).format("YYYY-MM-DD HH:mm:ss")
        : "",
      OrderMblNumber: mblNumber.value
      // SortColumnName: "",
      // SortDirection: "",
      // CurrentPage: 0,
      // PageSize: pageSize
    };
    await context.setReportData([]);
    onFillterHandler({ ...body });
    context.setModalOpen(false);
  };
  const onClear = () => {
    OrderNumber.setValue("");
    shipmentNumber.setValue("");
    incoTerm.setValue("");
    orderStatus.setValue("");
    orderDateFrom.setValue("");
    orderDateTo.setValue("");
    containerNumber.setValue("");
    BuyerCode.setValue("");
    BuyerName.setValue("");
    SupplierCode.setValue("");
    SupplierName.setValue("");
    containerMode.setValue("");
    transportMode.setValue("");
    Vessel.setValue("");
    Voyage.setValue("");
    CarrierCode.setValue("");
    OriginPortCode.setValue("");
    DestinationPortCode.setValue("");
    sendingAgentCode.setValue("");
    sendingAgentName.setValue("");
    recievingAgentCode.setValue("");
    recievingAgentName.setValue("");
    ETDFromDate.setValue("");
    ETDToDate.setValue("");
    ETAFromDate.setValue("");
    ETAToDate.setValue("");
    CutOffFromDate.setValue("");
    CutOffToDate.setValue("");
    mblNumber.setValue("");
    onFillterHandler({ ...filterDataObject });
  };

  return (
    <ModalBox title="Filter By">
      <div className="_modalBody container-fluid">
        <div className="row ">
          <div className="col-12">
            <Accordion defaultExpanded={true}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Order Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Order Number"
                      value={OrderNumber.value}
                      onChange={OrderNumber.onChange}
                      error={OrderNumber.error}
                      errorMsg={OrderNumber.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Shipment Number"
                      value={shipmentNumber.value}
                      onChange={shipmentNumber.onChange}
                      error={shipmentNumber.error}
                      errorMsg={shipmentNumber.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Inco Term"
                      value={incoTerm.value}
                      onChange={incoTerm.onChange}
                      error={incoTerm.error}
                      errorMsg={incoTerm.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Order Status"
                      value={orderStatus.value}
                      onChange={orderStatus.onChange}
                      error={orderStatus.error}
                      errorMsg={orderStatus.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="Order Date From"
                      value={orderDateFrom.value}
                      onChange={orderDateFrom.onDateChange}
                      error={orderDateFrom.error}
                      errorMsg={orderDateFrom.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="Order Date To"
                      value={orderDateTo.value}
                      onChange={orderDateTo.onDateChange}
                      error={orderDateTo.error}
                      errorMsg={orderDateTo.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Container Mode"
                      value={containerMode.value}
                      onChange={containerMode.onChange}
                      error={containerMode.error}
                      errorMsg={containerMode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Transport Mode"
                      value={transportMode.value}
                      onChange={transportMode.onChange}
                      error={transportMode.error}
                      errorMsg={transportMode.errorMsg}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Organization</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Buyer Code"
                      value={BuyerCode.value}
                      onChange={BuyerCode.onChange}
                      error={BuyerCode.error}
                      errorMsg={BuyerCode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Buyer Name"
                      value={BuyerName.value}
                      onChange={BuyerName.onChange}
                      error={BuyerName.error}
                      errorMsg={BuyerName.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Supplier Code"
                      value={SupplierCode.value}
                      onChange={SupplierCode.onChange}
                      error={SupplierCode.error}
                      errorMsg={SupplierCode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Supplier Name"
                      value={SupplierName.value}
                      onChange={SupplierName.onChange}
                      error={SupplierName.error}
                      errorMsg={SupplierName.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Sending Agent Code"
                      value={sendingAgentCode.value}
                      onChange={sendingAgentCode.onChange}
                      error={sendingAgentCode.error}
                      errorMsg={sendingAgentCode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Sending Agent Name"
                      value={sendingAgentName.value}
                      onChange={sendingAgentName.onChange}
                      error={sendingAgentName.error}
                      errorMsg={sendingAgentName.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Receiving Agent Code"
                      value={recievingAgentCode.value}
                      onChange={recievingAgentCode.onChange}
                      error={recievingAgentCode.error}
                      errorMsg={recievingAgentCode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Receiving Agent Name"
                      value={recievingAgentName.value}
                      onChange={recievingAgentName.onChange}
                      error={recievingAgentName.error}
                      errorMsg={recievingAgentName.errorMsg}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Planning</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="ETD Date From"
                      value={ETDFromDate.value}
                      onChange={ETDFromDate.onDateChange}
                      error={ETDFromDate.error}
                      errorMsg={ETDFromDate.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="ETD Date To"
                      value={ETDToDate.value}
                      onChange={ETDToDate.onDateChange}
                      error={ETDToDate.error}
                      errorMsg={ETDToDate.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="ETA Date From"
                      value={ETAFromDate.value}
                      onChange={ETAFromDate.onDateChange}
                      error={ETAFromDate.error}
                      errorMsg={ETAFromDate.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="ETA Date To"
                      value={ETAToDate.value}
                      onChange={ETAToDate.onDateChange}
                      error={ETAToDate.error}
                      errorMsg={ETAToDate.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="Cut-Off Date From"
                      value={CutOffFromDate.value}
                      onChange={CutOffFromDate.onDateChange}
                      error={CutOffFromDate.error}
                      errorMsg={CutOffFromDate.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate
                      label="Cut-Off Date To"
                      value={CutOffToDate.value}
                      onChange={CutOffToDate.onDateChange}
                      error={CutOffToDate.error}
                      errorMsg={CutOffToDate.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="MBL Number"
                      value={mblNumber.value}
                      onChange={mblNumber.onChange}
                      error={mblNumber.error}
                      errorMsg={mblNumber.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Container Number"
                      value={containerNumber.value}
                      onChange={containerNumber.onChange}
                      error={containerNumber.error}
                      errorMsg={containerNumber.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Vessel"
                      value={Vessel.value}
                      onChange={Vessel.onChange}
                      error={Vessel.error}
                      errorMsg={Vessel.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Voyage"
                      value={Voyage.value}
                      onChange={Voyage.onChange}
                      error={Voyage.error}
                      errorMsg={Voyage.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Carrier Code"
                      value={CarrierCode.value}
                      onChange={CarrierCode.onChange}
                      error={CarrierCode.error}
                      errorMsg={CarrierCode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Origin Port Code"
                      value={OriginPortCode.value}
                      onChange={OriginPortCode.onChange}
                      error={OriginPortCode.error}
                      errorMsg={OriginPortCode.errorMsg}
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText
                      label="Destination Port Code"
                      value={DestinationPortCode.value}
                      onChange={DestinationPortCode.onChange}
                      error={DestinationPortCode.error}
                      errorMsg={DestinationPortCode.errorMsg}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <div className="_modalFooter justify-content-between">
              <div className="_outlineButton">
                <button onClick={onClear}>Clear Filter</button>
              </div>
              <div className="_solidButton">
                <button onClick={onApplyFilters}>Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalBox>
  );
}

export default FilterModal;
